import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=125c48b8&"
import script from "./PageHeader.vue?vue&type=script&lang=js&"
export * from "./PageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125c48b8')) {
      api.createRecord('125c48b8', component.options)
    } else {
      api.reload('125c48b8', component.options)
    }
    module.hot.accept("./PageHeader.vue?vue&type=template&id=125c48b8&", function () {
      api.rerender('125c48b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/dahreply/PageHeader.vue"
export default component.exports